export default "/static/dashboard/build/app/img/v2/cb95a98678ee666bfeed95e9d87851a4.png";